import { useEffect, useRef, useContext, createContext } from 'react';
import { sortEventBuilder, columnFinder } from './Utils';

export const TableContext = createContext(null);

export const TableProvider = TableContext.Provider;

export const useTable = () => useContext(TableContext);

export const usePagination = () => {
	const {
		pageSize,
		rowCount,
		state: { page },
		setState,
	} = useTable();

	return {
		allowPagination: !!pageSize,
		totalPages: pageSize && Math.ceil(rowCount / pageSize),
		page,
		setPage: (nowPage) => setState((prev) => ({ ...prev, page: nowPage })),
	};
};

export const useSort = (dataIndex) => {
	const {
		columns,
		state: { sort },
		setState,
	} = useTable();

	const { sortable, sortDirection } = columnFinder(columns, dataIndex);
	return {
		sortOrder: dataIndex === sort.orderBy && sort.order,
		sortable: !!sortable,
		handleSort: sortable
			? sortEventBuilder(dataIndex, sort, setState, sortDirection)
			: undefined,
	};
};

export const useFilter = (dataIndex) => {
	const {
		columns,
		state: { filters: filterState },
		setState,
	} = useTable();
	const { filters, filterMultiple = true, filterSearch } = columnFinder(
		columns,
		dataIndex
	);
	return {
		filterable: !!(filters || filterSearch),
		filters,
		filterMultiple,
		filterSearch,
		filterState,
		setFilter: (callback) =>
			setState((prev) => ({
				...prev,
				page: 1,
				filters: callback(prev.filters),
			})),
	};
};

export const useColumn = (dataIndex) => {
	const { columns } = useTable();
	return columnFinder(columns, dataIndex);
};

export const usePrevious = (value) => {
	const previousRef = useRef();
	useEffect(() => {
		previousRef.current = value;
	});
	return previousRef.current;
};
